export const transformGetFeaturesWithDefaultsResponse = response => {
  return response.reduce((acc, feature) => {
    if (feature.shortName) {
      acc[feature.shortName] = feature;
    }
    return acc;
  }, {});
};